<template>
  <div data-modal="trigger-1" class="modal open" v-if="visible">
    <article class="content-wrapper">
      <button class="close" @click="close"></button>
      <header class="modal-header">
        <h2>{{title}}</h2>
      </header>
      <div class="content">
        <p>{{message}}</p>
      </div>
      <footer class="modal-footer">
        <button class="action accept" @click="close">{{$t('accept_label')}}</button>
      </footer>
    </article>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    title: String,
    message: String,
    visible: Boolean
  },
  components: {
  },

  data: () => ({

  }),
  computed: {

  },
  methods: {
    close: function () {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.trigger {
  margin: 0 0.75rem;
  padding: 0.625rem 1.25rem;
  border: none;
  border-radius: 0.25rem;
  box-shadow: 0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.12),
    0 0.0625rem 0.125rem rgba(0, 0, 0, 0.24);
  transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-size: 0.875rem;
  font-weight: 300;

  i {
    margin-right: 0.3125rem;
  }

  &:hover {
    box-shadow: 0 0.875rem 1.75rem rgba(0, 0, 0, 0.25),
      0 0.625rem 0.625rem rgba(0, 0, 0, 0.22);
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 0vh;
  background-color: transparent;
  overflow: hidden;
  transition: background-color 0.25s ease;
  z-index: 9999;

  &.open {
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    transition: background-color 0.25s;

    > .content-wrapper {
      transform: scale(1);
    }
  }

  .content-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 50%;
    margin: 0;
    padding: 2.5rem;
    background-color: white;
    border-radius: 0.3125rem;
    box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.5);
    transform: scale(0);
    transition: transform 0.25s;
    transition-delay: 0.15s;

    .close {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.5rem;
      height: 2.5rem;
      border: none;
      background-color: transparent;
      font-size: 1.5rem;
      transition: 0.25s linear;

      &:before,
      &:after {
        position: absolute;
        content: "";
        width: 1.25rem;
        height: 0.125rem;
        background-color: black;
      }

      &:before {
        transform: rotate(-45deg);
      }

      &:after {
        transform: rotate(45deg);
      }

      &:hover {
        transform: rotate(360deg);

        &:before,
        &:after {
          background-color: tomato;
        }
      }
    }

    .modal-header {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin: 0;
      padding: 0 0 1.25rem;

      h2 {
        font-size: 1.5rem;
        font-weight: bold;
      }
    }

    .content {
      position: relative;
      display: flex;

      p {
        font-size: 0.875rem;
        line-height: 1.75;
      }
    }

    .modal-footer {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      margin: 0;
      padding: 1.875rem 0 0;

      .action {
        position: relative;
        margin-left: 0.625rem;
        padding: 0.625rem 1.25rem;
        border: none;
        background-color: slategray;
        border-radius: 0.25rem;
        color: white;
        font-size: 0.87rem;
        font-weight: 300;
        overflow: hidden;
        z-index: 1;

        &:before {
          position: absolute;
          content: "";
          top: 0;
          left: 0;
          width: 0%;
          height: 100%;
          background-color: rgba(255, 255, 255, 0.2);
          transition: width 0.25s;
          z-index: 0;
        }

        &.accept {
          background-color: #2ecc71;
        }

        &.decline {
          background-color: #e74c3c;
        }

        &:hover {
          &:before {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
